import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  me: {
    role_list: []
  },
  menu_status: '显示菜单',
  currentCity: '湖北省'
}

const options = {
  state,
  mutations,
  actions,
  modules: {
  }
}

export default new Vuex.Store(options)



// WEBPACK FOOTER //
// ./src/store/index.js